function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5.14645 9.35355C5.34171 9.54882 5.65829 9.54882 5.85355 9.35355C6.04882 9.15829 6.04882 8.84171 5.85355 8.64645L3.70711 6.5H9.5C9.77614 6.5 10 6.27614 10 6C10 5.72386 9.77614 5.5 9.5 5.5H3.70711L5.85355 3.35355C6.04882 3.15829 6.04882 2.84171 5.85355 2.64645C5.65829 2.45118 5.34171 2.45118 5.14645 2.64645L2.14645 5.64645C2.05268 5.74021 2 5.86739 2 6C2 6.13261 2.05268 6.25978 2.14645 6.35355L5.14645 9.35355Z"
  }));
};

export default SvgComponent;